/* @flow */
/* eslint no-unused-vars: 0 */

import React from "react"

class ProductViewOptions extends React.PureComponent {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="product--view-options">
        <ul>
        </ul>
      </div>
    );
  }
}

export default ProductViewOptions;
